"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGraphqlQuery = useGraphqlQuery;
var _react = require("react");
var _swr = _interopRequireWildcard(require("swr"));
var _middleware = require("../middleware");
var _utils = require("../utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable @typescript-eslint/strict-boolean-expressions -- okay in this case as value can be generic */

/**
 * It takes a GraphQL query, variables, and a url, and returns a SWR response
 * @param {QueryOptions} [options] - The parameters represents an object which contains properties for the Graphql fetcher function
 */
function useGraphqlQuery(options) {
  const {
    url,
    skip,
    swrConfig,
    createCacheKey,
    onError,
    timeout,
    ...fetcherOptions
  } = options ?? {
    skip: true
  };
  const {
    cache
  } = (0, _swr.useSWRConfig)();
  const cacheKey = (0, _react.useMemo)(() => createCacheKey ? createCacheKey({
    url,
    ...fetcherOptions
  }) : (0, _utils.createSimplifiedCacheKey)({
    url,
    ...fetcherOptions
  }), [createCacheKey, url, fetcherOptions]);
  const configForSWR = (0, _react.useMemo)(() => swrConfig ? {
    ...swrConfig,
    use: [...(swrConfig.use ?? []), ...(swrConfig.fallbackData ? [_middleware.initialDataMiddleware] : [])],
    revalidateOnMount: !cache.get((0, _swr.unstable_serialize)(cacheKey))
  } : {
    revalidateOnMount: !cache.get((0, _swr.unstable_serialize)(cacheKey))
  }, [swrConfig, cache, cacheKey]);
  return (0, _swr.default)(skip ? null : cacheKey, async () => (0, _utils.fetchGraphql)({
    url,
    onError,
    timeout,
    ...fetcherOptions
  }), configForSWR);
}
//# sourceMappingURL=useGraphqlQuery.js.map